module.exports = __webpack_public_path__ + "static/img/wechat.27ffdd9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/wechat.jpg
// module id = HHxi
// module chunks = 1